import { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { IoMdClose } from "react-icons/io";
import { useDispatch } from "react-redux";
import nodeinstance from "../../../../nodeInstance";
import { getVisaRequestData } from "../../../../store/Api";
import { setAppError } from "../../../../store/userSlice";

export default function VrfConformationpopup({ propData, popUp, setPopUp }) {
  console.log("propData", propData);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      let reqObject = {
        status: "OPS1 CONFIRMED",
        visa_profession_id: data.visa_profession_id,
        company_id: data.company_id,
        allocated_visa: data.total_visa,
        available_visa: data.total_visa,
        vrf_id: data?.id,
      };
      console.log("data", data);
      const response = await nodeinstance.put(
        `/dashboard/vrf-visa/updateVRFByOpsDesk/${data?.id}`,
        reqObject,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      if (response.status === 200) {
        dispatch(getVisaRequestData(token));
        dispatch(
          setAppError({
            msg: "Status Updated successfully.",
            color: "success",
          })
        );
        setPopUp(false)
        setLoading(false);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
      setLoading(false);
    }
    setPopUp(false)
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50 justify-center items-center ${
          popUp ? "flex" : "hidden"
        }`}
      >
        {/* <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative"> */}
        <div className="max-w-lg w-full h-[180px] overflow-auto rounded-md bg-white/95 flex flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUp(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <h2 className="mt-5">
            ARE YOU SURE TO CONFIRM THIS VISA REQUEST?
          </h2>
          <div className="flex gap-3 w-full justify-center mt-5">
          <button
            className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
            onClick={() => {
              onSubmit(propData);
            }}
          >
            {loading ? (
              <CgSpinner className="animate-spin mx-auto" />
            ) : (
              "CONFIRM"
            )}
          </button>
        </div>
        </div>
     
      </div>
    </>
  );
}
